import { create } from 'zustand';

interface Message {
  id: string;
  type: 'user' | 'arbiter';
  content: string;
  timestamp: Date;
}

interface ArbiterState {
  panelOpen: boolean;
  messages: Message[];
  isProcessing: boolean;
  togglePanel: () => void;
  setPanelOpen: (open: boolean) => void;
  addMessage: (message: Omit<Message, 'id' | 'timestamp'>) => void;
  setProcessing: (processing: boolean) => void;
  clearMessages: () => void;
}

export const useArbiterStore = create<ArbiterState>((set) => ({
  panelOpen: false,
  messages: [],
  isProcessing: false,
  togglePanel: () => set((state) => ({ panelOpen: !state.panelOpen })),
  setPanelOpen: (open: boolean) => set({ panelOpen: open }),
  addMessage: (message) =>
    set((state) => ({
      messages: [
        ...state.messages,
        {
          ...message,
          id: `msg-${Date.now()}-${Math.random()}`,
          timestamp: new Date(),
        },
      ],
    })),
  setProcessing: (processing: boolean) => set({ isProcessing: processing }),
  clearMessages: () => set({ messages: [] }),
}));
